export const buildErrorMessage = (error) => {
	let message;
	if (!error) {
		return message;
	}

	if (error.response) {
		message = `Request ${error.response.config?.method.toUpperCase()}' '${
			error.response.config?.url
		}, params:${JSON.stringify(error.response.config?.params)} failed, status:${
			error.response.status
		}`;
	} else {
		message = error.message;

		if (error.stack) {
			message += ` sourceFunction:${error.stack.split('\n')[1]}`;
		}
		if (error.config) {
			message += ` request: ${error.config.method} ${error.config.url}`;
		}
	}
	return message || JSON.stringify(error);
};
